import React from "react";
import { PlayerControls } from "./PlayerControls";
import styles from "./ArtbookControls.module.scss";
import { SoundtrackControls } from "./SoundtrackControls";
import { UserControls } from "./UserControls";
import { useAtomValue } from "jotai";
import { TutorialAnimation } from "@/components//TutorialAnimation";
import { CameraIntroComplete, PageSelectorVisible, SoundtrackEnabled, } from "@/atoms";
import classNames from "classnames";
export function ArtbookControls(_a) {
    var _b, _c;
    var visible = _a.visible;
    var introComplete = useAtomValue(CameraIntroComplete);
    var selectorVisible = useAtomValue(PageSelectorVisible);
    var soundtrackEnabled = useAtomValue(SoundtrackEnabled);
    return (React.createElement("div", { className: classNames(styles.artbookControls, (_b = {},
            _b[styles.visible] = visible,
            _b)) },
        soundtrackEnabled ? React.createElement(SoundtrackControls, null) : React.createElement("div", null),
        React.createElement("div", { className: classNames(styles.closeLayer, (_c = {},
                _c[styles.visible] = selectorVisible,
                _c)) }),
        React.createElement(PlayerControls, { sfxControl: !soundtrackEnabled }),
        React.createElement(UserControls, null),
        introComplete && (React.createElement("div", { className: styles.interactionSignal },
            React.createElement(TutorialAnimation, null)))));
}
